import React, { useEffect, useMemo, useState } from 'react';
import { SideMenuProps } from '@elem/compCommon/SideMenu';
import D from './components/D';
import style from './index.module.scss';
import PcComp from './components/PcComp';
import { ids, PAGE_LINK } from './data';
import { useLang } from '@/i18n';
import getLocal from '@/app/utils/i18n';
import useProductInfo from '@/utils/hooks/useProductInfo';

interface Props {
    obj: SideMenuProps;
}

const Preparing: React.FC<Props> = ({ obj }) => {
    const { t } = useLang('powerbackup.Preparing');
    const { locale } = getLocal();

    const [active, setActive] = useState(obj.items[0].link);
    const [isPC, setIsPC] = useState(true);
    useEffect(() => {
        if (typeof window !== 'undefined') {
            const callback = () => {
                setIsPC(window.innerWidth > 1024);
            };
            callback();
            window.addEventListener('resize', callback);
            return () => window.removeEventListener('resize', callback);
        }
    }, []);

    const usProductsListE = [
        { label: t('i1_product1_label'), desc: t('i1_product1_desc') },
        { label: t('i1_product2_label'), desc: t('i1_product2_desc') },
        { label: t('i1_product5_label'), desc: t('i1_product5_desc') },
        { label: t('i1_product4_label'), desc: t('i1_product4_desc') },
        { label: t('i1_product3_label'), desc: t('i1_product3_desc') },
        { label: t('i1_product6_label'), desc: t('i1_product6_desc') },
    ];
    const caProductsListE = [
        { label: t('i1_product1_label'), desc: t('i1_product1_desc') },
        { label: t('i1_product2_label'), desc: t('i1_product2_desc') },
        { label: t('i1_product5_label'), desc: t('i1_product5_desc') },
        // { label: t('i1_product3_label'), desc: t('i1_product3_desc') },
        { label: t('i1_product4_label'), desc: t('i1_product4_desc') },
        { label: t('i1_product6_label'), desc: t('i1_product6_desc') },
    ];
    const productsListMapE = {
        us: usProductsListE,
        ca: caProductsListE,
    };

    const finalProductsListE = productsListMapE[locale as 'us' | 'ca'] || usProductsListE;

    const usProductsListF = [
        { label: t('i2_product5_label'), desc: t('i2_product5_desc') },
        { label: t('i2_product1_label'), desc: t('i2_product1_desc') },
        { label: t('i2_product6_label'), desc: t('i2_product6_desc') },
        { label: t('i2_product2_label'), desc: t('i2_product2_desc') },
        { label: t('i2_product3_label'), desc: t('i2_product3_desc') },
        { label: t('i2_product4_label'), desc: t('i2_product4_desc') },
    ];
    const caProductsListF = [
        { label: t('i2_product5_label'), desc: t('i2_product5_desc') },
        { label: t('i2_product1_label'), desc: t('i2_product1_desc') },
        { label: t('i2_product6_label'), desc: t('i2_product6_desc') },
        { label: t('i2_product2_label'), desc: t('i2_product2_desc') },
        { label: t('i2_product7_label'), desc: t('i2_product7_desc') },
        { label: t('i2_product4_label'), desc: t('i2_product4_desc') },
    ];
    const productsListMapF = {
        us: usProductsListF,
        ca: caProductsListF,
    };

    const finalProductsListF = productsListMapF[locale as 'us' | 'ca'] || usProductsListF;
    const usProductsListG = [
        { label: t('i3_product1_label'), desc: t('i3_product1_desc') },
        { label: t('i3_product2_label'), desc: t('i3_product2_desc') },
        { label: t('i3_product3_label'), desc: t('i3_product3_desc') },
    ];
    const caProductsListG = [
        // { label: t('i3_product1_label'), desc: t('i3_product1_desc') },
        { label: t('i3_product4_label'), desc: t('i3_product4_desc') },
        { label: t('i3_product2_label'), desc: t('i3_product2_desc') },
        { label: t('i3_product3_label'), desc: t('i3_product3_desc') },
    ];
    const productsListMapG = {
        us: usProductsListG,
        ca: caProductsListG,
    };

    const finalProductsListG = productsListMapG[locale as 'us' | 'ca'] || usProductsListG;

    const list = [
        {
            key: PAGE_LINK.E,
            label: t('label1'),
            title: t('title1'),
            desc: t('desc1'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1747293808203/1.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1747293808037/1-h5.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1747293808037/1-h5.jpg',
            icons: [
                { pc: 'https://websiteoss.ecoflow.com/upload/image/1747883385649/1.png', text: t('i1_icon1') },
                { pc: 'https://websiteoss.ecoflow.com/upload/image/1747883385824/2.png', text: t('i1_icon2') },
                { pc: 'https://websiteoss.ecoflow.com/upload/image/1747883386048/3.png', text: t('i1_icon3') },
                { pc: 'https://websiteoss.ecoflow.com/upload/image/1747883386189/4.png', text: t('i1_icon4') },
            ],
            products: finalProductsListE,
        },
        {
            key: PAGE_LINK.F,
            label: t('label2'),
            title: t('title2'),
            desc: t('desc2'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1747293808569/2.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1747293808387/2-h5.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1747293808387/2-h5.jpg',
            icons: [
                { pc: 'https://websiteoss.ecoflow.com/upload/image/1747883386367/5.png', text: t('i2_icon1') },
                { pc: 'https://websiteoss.ecoflow.com/upload/image/1747883385649/1.png', text: t('i2_icon2') },
                { pc: 'https://websiteoss.ecoflow.com/upload/image/1747883386189/4.png', text: t('i2_icon3') },
                { pc: 'https://websiteoss.ecoflow.com/upload/image/1747883386678/6.png', text: t('i2_icon4') },
            ],
            products: finalProductsListF,
        },
        {
            key: PAGE_LINK.G,
            label: t('label3'),
            title: t('title3'),
            desc: t('desc3'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1760082014083/Frame%20161269586.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1760088894720/H5-Frame%201612707566.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1760088894720/H5-Frame%201612707566.jpg',
            icons: [
                { pc: 'https://websiteoss.ecoflow.com/upload/image/1747883386876/7.png', text: t('i3_icon1') },
                { pc: 'https://websiteoss.ecoflow.com/upload/image/1747883387167/8.png', text: t('i3_icon2') },
                { pc: 'https://websiteoss.ecoflow.com/upload/image/1747883386048/3.png', text: t('i3_icon3') },
                { pc: 'https://websiteoss.ecoflow.com/upload/image/1747883386678/6.png', text: t('i3_icon4') },
            ],
            products: finalProductsListG,
        },
        {
            key: PAGE_LINK.H,
            label: t('label4'),
            title: t('title4'),
            desc: t('desc4'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1752824334422/4.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1752824355291/4-h5.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1752824355291/4-h5.jpg',
            icons: [
                { pc: 'https://websiteoss.ecoflow.com/upload/image/1747883385649/1.png', text: t('i4_icon1') },
                { pc: 'https://websiteoss.ecoflow.com/upload/image/1747883385824/2.png', text: t('i4_icon2') },
                { pc: 'https://websiteoss.ecoflow.com/upload/image/1747883386048/3.png', text: t('i4_icon3') },
                { pc: 'https://websiteoss.ecoflow.com/upload/image/1747883386189/4.png', text: t('i4_icon4') },
            ],
            productInfo: {
                label: t(`i4_product_label`),
                title: t(`i4_product_title`),
                desc: t(`i4_product_desc`),
                btn: t(`i4_product_btn`),
                img: {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1753067523603/i4-product.png',
                    pad: 'https://websiteoss.ecoflow.com/upload/image/1753067523525/i4-product-h5.png',
                    h5: 'https://websiteoss.ecoflow.com/upload/image/1753067523525/i4-product-h5.png',
                },
                herf: 'https://www.ecoflow.com/us/ocean-pro-consultation?utm_source=oceanpro&utm_medium=orderpage',
            },
        },
    ];
    const curIds = ids[locale as 'us'] || ids['us'];

    /**
     * 处理接口数据
     */
    const productsE = (curIds[PAGE_LINK.E] || []).map((id: any, i: number) => ({ ...id, ...(finalProductsListE[i] || {}) }));
    const productsF = (curIds[PAGE_LINK.F] || []).map((id: any, i: number) => ({ ...id, ...(finalProductsListF[i] || {}) }));
    const productsG = (curIds[PAGE_LINK.G] || []).map((id: any, i: number) => ({ ...id, ...(finalProductsListG[i] || {}) }));

    const p1 = useProductInfo(productsE, {}, false, true);
    const p2 = useProductInfo(productsF, {}, false, true);
    const p3 = useProductInfo(productsG, {}, false, true);
    //这三个要求写死title
    const titles: { [key: string]: any } = {
        54714781171785: '1 × EcoFlow DELTA Pro Ultra X Inverter + 2 × Smart Extra Battery',
        54714781204553: '1 × EcoFlow DELTA Pro Ultra X Inverter + 2 × Smart Extra Battery + 1 × EcoFlow Smart Home Panel 3',
        62111365792115: '1 × EcoFlow DELTA Pro Ultra X Inverter + 2 × Smart Extra Battery',
    };
    const data = useMemo(() => {
        const newList: unknown[] = [];
        const p_list = [p1, p2, p3];
        p_list.map((products, idx1) => {
            const item = list[idx1];

            newList.push({
                ...item,
                products: (products || []).map((product: any) => {
                    if (['62111365792115', '54714781171785', '54714781204553'].includes(product.variantId)) {
                        product.title = titles[product.variantId];
                    }
                    return product;
                }),
            });
        });

        if (locale === 'us') {
            newList.push(list.find((item) => item.key === PAGE_LINK.H));
        }

        return newList;
    }, [p1, p2, p3]);

    return (
        <div className={`${style.Preparing}`}>
            <D
                tags={obj.items}
                handleClick={(tag: any) => {
                    setActive(tag?.link);
                    // 定位
                    if (tag?.link) {
                        const dom = document.getElementById(tag?.link);
                        if (dom) {
                            dom.scrollIntoView({ behavior: 'smooth' });
                        }
                    }
                }}
            />
            {data.map((i: any, idx) => (isPC ? i.key === active ? <PcComp item={i} id={i.key} key={idx} /> : null : <PcComp item={i} id={i.key} key={idx} />))}
        </div>
    );
};
export default Preparing;
